// extracted by mini-css-extract-plugin
export var content = "ProfileCompletionModal-module--content--21626";
export var submitButton = "ProfileCompletionModal-module--submitButton--74166";